import React from "react";

import type {
  Procedure,
  ProcedureDetail,
  ProcValidation,
} from "../../../../application/domain/proc-management";
import {
  ProcedureTargetInput,
  ProcedureDetailedRequirementInput,
  ProcedureTriggerInput,
  ProcedureDeadlineInput,
} from "../../../molecules/proc-management/form";

type Props = {
  procedure: ProcedureDetail | Procedure;
  onChange: (path: (string | number)[], value: any) => void;
  disabled?: boolean;
  shouldDisplayError: boolean;
  validationErrors: ProcValidation;
};

export const RequirementSection: React.FC<Props> = ({
  procedure,
  onChange,
  disabled = false,
  shouldDisplayError = false,
  validationErrors,
}) => {
  return (
    <section className="mb-5">
      <h2 className="subtitle">手続きの要件</h2>

      <ProcedureTargetInput
        onChange={onChange}
        basePath={["target"]}
        value={procedure.target}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={validationErrors.target}
      />

      <ProcedureDetailedRequirementInput
        onChange={onChange}
        basePath={["detailedRequirement"]}
        value={procedure.detailedRequirement}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={validationErrors.detailedRequirement}
      />

      <ProcedureTriggerInput
        onChange={onChange}
        basePath={["trigger"]}
        value={procedure.trigger}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={validationErrors.trigger}
      />

      <ProcedureDeadlineInput
        onChange={onChange}
        basePath={["deadline"]}
        value={procedure.deadline}
        disabled={disabled}
        shouldDisplayError={shouldDisplayError}
        errorMsg={validationErrors.deadline}
      />
    </section>
  );
};
